import React from 'react';

const LocationPin = ({ width = 24, height = 24, fill = '#666666', ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 16.475C13.65 15.1417 14.8958 13.8583 15.7375 12.625C16.5792 11.3917 17 10.2333 17 9.15C17 7.65 16.5333 6.41667 15.6 5.45C14.6667 4.48333 13.4667 4 12 4C10.5333 4 9.33333 4.48333 8.4 5.45C7.46667 6.41667 7 7.65 7 9.15C7 10.2333 7.42083 11.3917 8.2625 12.625C9.10417 13.8583 10.35 15.1417 12 16.475ZM12 19C9.65 17.2667 7.89583 15.5833 6.7375 13.95C5.57917 12.3167 5 10.7167 5 9.15C5 7.06667 5.65 5.35417 6.95 4.0125C8.25 2.67083 9.93333 2 12 2C14.0667 2 15.75 2.67083 17.05 4.0125C18.35 5.35417 19 7.06667 19 9.15C19 10.7167 18.4208 12.3167 17.2625 13.95C16.1042 15.5833 14.35 17.2667 12 19ZM12 11C12.55 11 13.0208 10.8042 13.4125 10.4125C13.8042 10.0208 14 9.55 14 9C14 8.45 13.8042 7.97917 13.4125 7.5875C13.0208 7.19583 12.55 7 12 7C11.45 7 10.9792 7.19583 10.5875 7.5875C10.1958 7.97917 10 8.45 10 9C10 9.55 10.1958 10.0208 10.5875 10.4125C10.9792 10.8042 11.45 11 12 11ZM5 22V20H19V22H5Z" fill={fill}/>
  </svg>
);

export default LocationPin;
